import { render, staticRenderFns } from "./heatmapEventsConfig.vue?vue&type=template&id=9f98a3b0&scoped=true"
import script from "./heatmapEventsConfig.vue?vue&type=script&lang=js"
export * from "./heatmapEventsConfig.vue?vue&type=script&lang=js"
import style0 from "./heatmapEventsConfig.vue?vue&type=style&index=0&id=9f98a3b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f98a3b0",
  null
  
)

export default component.exports